import { ActivityIndicator } from '../ActivityIndicator';

const DashboardFireRegister = ({
    fireRegisterData,
    registerLoading,
    fetchFireRegisterData,
    handleSignIn,
    handleSignOut,
    adminList,
    driversList,
    theme,
    signInMode,
    setSignInMode,
    selectedPerson,
    setSelectedPerson,
    showAlert
}) => {
    return (
        <div style={{ 
            minHeight: '100vh',
            background: `linear-gradient(135deg, rgba(255, 87, 34, 0.1) 0%, rgba(255, 87, 34, 0.05) 100%)`,
            padding: '20px',
            borderRadius: '10px'
        }}>
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <h2 style={{ color: theme === 'light' ? '#333' : '#fff', marginBottom: '10px' }}>
                    🔥 Fire Register - {new Date().toLocaleDateString('en-GB')}
                </h2>
                <p style={{ color: theme === 'light' ? '#666' : '#ccc', fontSize: '16px' }}>
                    Track who's currently onsite
                </p>
            </div>

            {/* Sign In/Out Controls */}
            <div style={{
                background: theme === 'light' ? '#fff' : '#333',
                padding: '20px',
                borderRadius: '12px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                marginBottom: '30px',
                border: '1px solid ' + (theme === 'light' ? '#e0e0e0' : '#555')
            }}>
                <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                    marginBottom: '15px' 
                }}>
                    <h4 style={{ color: theme === 'light' ? '#333' : '#fff', margin: 0 }}>
                        Sign In/Out
                    </h4>
                    <button
                        onClick={fetchFireRegisterData}
                        disabled={registerLoading}
                        style={{
                            padding: '6px 12px',
                            backgroundColor: registerLoading ? '#6c757d' : '#17a2b8',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: registerLoading ? 'not-allowed' : 'pointer',
                            fontSize: '14px'
                        }}
                    >
                        Refresh
                    </button>
                </div>
                
                {/* Mode Toggle */}
                <div style={{ marginBottom: '15px', display: 'flex', gap: '10px' }}>
                    <button
                        onClick={() => {
                            setSignInMode('dropdown');
                            setSelectedPerson('');
                        }}
                        style={{
                            padding: '6px 12px',
                            backgroundColor: signInMode === 'dropdown' ? '#007bff' : '#6c757d',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px'
                        }}
                    >
                        Select Staff Member
                    </button>
                    <button
                        onClick={() => {
                            setSignInMode('manual');
                            setSelectedPerson('');
                        }}
                        style={{
                            padding: '6px 12px',
                            backgroundColor: signInMode === 'manual' ? '#007bff' : '#6c757d',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                            fontSize: '14px'
                        }}
                    >
                        Manual Entry
                    </button>
                </div>

                {/* Dropdown Mode */}
                {signInMode === 'dropdown' && (
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
                        <select
                            value={selectedPerson}
                            onChange={(e) => setSelectedPerson(e.target.value)}
                            style={{
                                padding: '8px 12px',
                                borderRadius: '6px',
                                border: '1px solid #ccc',
                                background: theme === 'light' ? '#fff' : '#444',
                                color: theme === 'light' ? '#333' : '#fff',
                                width: '30%',
                                minWidth: '200px'
                            }}
                        >
                            <option value="">Select a person...</option>
                            <optgroup label="Staff Members">
                                {[...adminList, ...driversList]
                                    .filter((person) => {
                                        // Filter out people who are already signed in
                                        return !fireRegisterData.some(entry => 
                                            entry.name === person.name && 
                                            entry.surname === person.surname && 
                                            !entry.time_out // Only exclude if they haven't signed out
                                        );
                                    })
                                    .sort((a, b) => `${a.name} ${a.surname}`.localeCompare(`${b.name} ${b.surname}`))
                                    .map((person) => (
                                        <option key={person.id} value={JSON.stringify(person)}>
                                            {person.name} {person.surname} ({person.group})
                                        </option>
                                    ))
                                }
                            </optgroup>
                        </select>
                        <button
                            onClick={() => {
                                if (selectedPerson) {
                                    const person = JSON.parse(selectedPerson);
                                    const timeIn = new Date().toLocaleTimeString([], {
                                        hour: '2-digit', 
                                        minute: '2-digit',
                                        hour12: true
                                    });
                                    
                                    handleSignIn(person.name, person.surname, 'Customer 1st', timeIn, person.id);
                                    setSelectedPerson('');
                                } else {
                                    showAlert({
                                        message: 'Please select a person from the dropdown.',
                                        type: 'warning',
                                        buttons: [{ type: 'warning', label: 'OK' }],
                                    });
                                }
                            }}
                            disabled={registerLoading || !selectedPerson}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: (!selectedPerson || registerLoading) ? '#6c757d' : '#28a745',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: (!selectedPerson || registerLoading) ? 'not-allowed' : 'pointer'
                            }}
                        >
                            Sign In
                        </button>
                    </div>
                )}

                {/* Manual Mode */}
                {signInMode === 'manual' && (
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
                        <input
                            type="text"
                            placeholder="First Name"
                            id="firstName"
                            style={{
                                padding: '8px 12px',
                                borderRadius: '6px',
                                border: '1px solid #ccc',
                                background: theme === 'light' ? '#fff' : '#444',
                                color: theme === 'light' ? '#333' : '#fff'
                            }}
                        />
                        <input
                            type="text"
                            placeholder="Last Name"
                            id="lastName"
                            style={{
                                padding: '8px 12px',
                                borderRadius: '6px',
                                border: '1px solid #ccc',
                                background: theme === 'light' ? '#fff' : '#444',
                                color: theme === 'light' ? '#333' : '#fff'
                            }}
                        />
                        <input
                            type="text"
                            placeholder="Company"
                            id="company"
                            style={{
                                padding: '8px 12px',
                                borderRadius: '6px',
                                border: '1px solid #ccc',
                                background: theme === 'light' ? '#fff' : '#444',
                                color: theme === 'light' ? '#333' : '#fff'
                            }}
                        />
                        <button
                            onClick={() => {
                                const firstName = document.getElementById('firstName').value;
                                const lastName = document.getElementById('lastName').value;
                                const company = document.getElementById('company').value;
                                const timeIn = new Date().toLocaleTimeString([], {
                                    hour: '2-digit', 
                                    minute: '2-digit',
                                    hour12: true
                                });
                                
                                if (firstName && lastName && company) {
                                    handleSignIn(firstName, lastName, company, timeIn);
                                    document.getElementById('firstName').value = '';
                                    document.getElementById('lastName').value = '';
                                    document.getElementById('company').value = '';
                                } else {
                                    showAlert({
                                        message: 'Please fill in all fields.',
                                        type: 'warning',
                                        buttons: [{ type: 'warning', label: 'OK' }],
                                    });
                                }
                            }}
                            disabled={registerLoading}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: registerLoading ? '#6c757d' : '#28a745',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: registerLoading ? 'not-allowed' : 'pointer'
                            }}
                        >
                            Sign In
                        </button>
                    </div>
                )}

            </div>

            {/* Register Table */}
            {registerLoading ? (
                <div style={{ textAlign: 'center', padding: '50px' }}>
                    <ActivityIndicator />
                </div>
            ) : (
                <div style={{
                    background: theme === 'light' ? '#fff' : '#333',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                    border: '1px solid ' + (theme === 'light' ? '#e0e0e0' : '#555')
                }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr style={{ 
                                background: theme === 'light' ? '#f8f9fa' : '#444',
                                borderBottom: '2px solid ' + (theme === 'light' ? '#dee2e6' : '#555')
                            }}>
                                <th style={{ padding: '15px', textAlign: 'left', color: theme === 'light' ? '#333' : '#fff' }}>Name</th>
                                <th style={{ padding: '15px', textAlign: 'left', color: theme === 'light' ? '#333' : '#fff' }}>Company</th>
                                <th style={{ padding: '15px', textAlign: 'center', color: theme === 'light' ? '#333' : '#fff' }}>Time In</th>
                                <th style={{ padding: '15px', textAlign: 'center', color: theme === 'light' ? '#333' : '#fff' }}>Time Out</th>
                                <th style={{ padding: '15px', textAlign: 'center', color: theme === 'light' ? '#333' : '#fff' }}>Status</th>
                                <th style={{ padding: '15px', textAlign: 'center', color: theme === 'light' ? '#333' : '#fff' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {fireRegisterData.length > 0 ? (
                                fireRegisterData.map((person, index) => {
                                    const isOnsite = !person.time_out;
                                    const isCustomer1st = person.company === 'Customer 1st';
                                    
                                    return (
                                        <tr
                                            key={person.id || index}
                                            style={{
                                                backgroundColor: !isOnsite 
                                                    ? (theme === 'light' ? '#f8f9fa' : '#2a2a2a') 
                                                    : isCustomer1st
                                                        ? (theme === 'light' ? '#e8f5e8' : '#1a3d1a')
                                                        : (theme === 'light' ? '#e6f3ff' : '#1a2d3d'),
                                                opacity: isOnsite ? 1 : 0.6,
                                                borderBottom: '1px solid ' + (theme === 'light' ? '#dee2e6' : '#555')
                                            }}
                                        >
                                            <td style={{ 
                                                padding: '12px 15px',
                                                color: theme === 'light' ? '#333' : '#fff',
                                                fontWeight: isCustomer1st && isOnsite ? 'bold' : 'normal'
                                            }}>
                                                {person.name} {person.surname}
                                            </td>
                                            <td style={{ 
                                                padding: '12px 15px',
                                                color: theme === 'light' ? '#333' : '#fff',
                                                fontWeight: isCustomer1st && isOnsite ? 'bold' : 'normal'
                                            }}>
                                                {person.company}
                                                {isCustomer1st && isOnsite && (
                                                    <span style={{ 
                                                        marginLeft: '8px',
                                                        fontSize: '12px',
                                                        backgroundColor: '#28a745',
                                                        color: 'white',
                                                        padding: '2px 6px',
                                                        borderRadius: '10px'
                                                    }}>
                                                        Staff
                                                    </span>
                                                )}
                                            </td>
                                            <td style={{ 
                                                padding: '12px 15px',
                                                textAlign: 'center',
                                                color: theme === 'light' ? '#333' : '#fff'
                                            }}>
                                                {person.time_in}
                                            </td>
                                            <td style={{ 
                                                padding: '12px 15px',
                                                textAlign: 'center',
                                                color: theme === 'light' ? '#333' : '#fff'
                                            }}>
                                                {person.time_out || '--'}
                                            </td>
                                            <td style={{ 
                                                padding: '12px 15px',
                                                textAlign: 'center'
                                            }}>
                                                <span style={{
                                                    padding: '4px 8px',
                                                    borderRadius: '12px',
                                                    fontSize: '12px',
                                                    fontWeight: 'bold',
                                                    backgroundColor: isOnsite ? '#28a745' : '#dc3545',
                                                    color: 'white'
                                                }}>
                                                    {isOnsite ? 'ONSITE' : 'LEFT'}
                                                </span>
                                            </td>
                                            <td style={{ 
                                                padding: '12px 15px',
                                                textAlign: 'center'
                                            }}>
                                                {isOnsite ? (
                                                    <button
                                                        onClick={() => {
                                                            const timeOut = new Date().toLocaleTimeString([], {
                                                                hour: '2-digit', 
                                                                minute: '2-digit',
                                                                hour12: true
                                                            });
                                                            handleSignOut(person.id, timeOut);
                                                        }}
                                                        disabled={registerLoading}
                                                        style={{
                                                            padding: '4px 8px',
                                                            backgroundColor: '#dc3545',
                                                            color: 'white',
                                                            border: 'none',
                                                            borderRadius: '4px',
                                                            fontSize: '12px',
                                                            cursor: registerLoading ? 'not-allowed' : 'pointer'
                                                        }}
                                                    >
                                                        Sign Out
                                                    </button>
                                                ) : (
                                                    <span style={{ 
                                                        color: theme === 'light' ? '#666' : '#999',
                                                        fontSize: '12px'
                                                    }}>
                                                        --
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td 
                                        colSpan="6" 
                                        style={{ 
                                            padding: '30px',
                                            textAlign: 'center',
                                            color: theme === 'light' ? '#666' : '#999',
                                            fontStyle: 'italic'
                                        }}
                                    >
                                        No entries for today
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Summary Stats */}
            {!registerLoading && fireRegisterData.length > 0 && (
                <div style={{ 
                    marginTop: '20px',
                    display: 'grid', 
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
                    gap: '15px'
                }}>
                    <div style={{
                        background: theme === 'light' ? '#fff' : '#333',
                        padding: '15px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        border: '1px solid ' + (theme === 'light' ? '#e0e0e0' : '#555'),
                        textAlign: 'center'
                    }}>
                        <h4 style={{ color: '#28a745', margin: '0 0 5px 0' }}>
                            {fireRegisterData.filter(p => !p.time_out).length}
                        </h4>
                        <p style={{ color: theme === 'light' ? '#666' : '#ccc', margin: '0', fontSize: '14px' }}>
                            Currently Onsite
                        </p>
                    </div>
                    <div style={{
                        background: theme === 'light' ? '#fff' : '#333',
                        padding: '15px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        border: '1px solid ' + (theme === 'light' ? '#e0e0e0' : '#555'),
                        textAlign: 'center'
                    }}>
                        <h4 style={{ color: '#17a2b8', margin: '0 0 5px 0' }}>
                            {fireRegisterData.filter(p => !p.time_out && p.company === 'Customer 1st').length}
                        </h4>
                        <p style={{ color: theme === 'light' ? '#666' : '#ccc', margin: '0', fontSize: '14px' }}>
                            Staff Onsite
                        </p>
                    </div>
                    <div style={{
                        background: theme === 'light' ? '#fff' : '#333',
                        padding: '15px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        border: '1px solid ' + (theme === 'light' ? '#e0e0e0' : '#555'),
                        textAlign: 'center'
                    }}>
                        <h4 style={{ color: '#ffc107', margin: '0 0 5px 0' }}>
                            {fireRegisterData.filter(p => !p.time_out && p.company !== 'Customer 1st').length}
                        </h4>
                        <p style={{ color: theme === 'light' ? '#666' : '#ccc', margin: '0', fontSize: '14px' }}>
                            Visitors Onsite
                        </p>
                    </div>
                    <div style={{
                        background: theme === 'light' ? '#fff' : '#333',
                        padding: '15px',
                        borderRadius: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        border: '1px solid ' + (theme === 'light' ? '#e0e0e0' : '#555'),
                        textAlign: 'center'
                    }}>
                        <h4 style={{ color: '#dc3545', margin: '0 0 5px 0' }}>
                            {fireRegisterData.filter(p => p.time_out).length}
                        </h4>
                        <p style={{ color: theme === 'light' ? '#666' : '#ccc', margin: '0', fontSize: '14px' }}>
                            Left Today
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DashboardFireRegister;